import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PatientSphereAction, SPHERE} from '../../models/patient-sphere';
import {IPatient, PatientState} from '../../models/patient';
import {PhysicalActivityLevelEnum, RecordTypeEnum} from '../../enums/record';
import {PatientGoalNumberTypeEnum} from '../../enums/patient-goal';
import {GenderEnum} from '../../models/user';
import {AuthState, IUser} from '../../models/auth';
import {NzMarks} from 'ng-zorro-antd/slider';
import {ILevelActivityValues} from '../important-info-patient/important-info-patient.component';
import {SphereModeEnum} from '../../enums/sphere/sphere-mode.enum';
import {Select, Store} from '@ngxs/store';
import {ServiceAction, ServiceState} from '../../models/service';
import {firstValueFrom, Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {SkeletonEnum} from '../../enums/skeleton';
import {SkeletonService} from '../../services/skeleton/skeleton.service';

@Component({
  selector: 'app-complete-record-sphere',
  templateUrl: './complete-record-sphere.component.html',
  styleUrls: ['./complete-record-sphere.component.scss']
})
export class CompleteRecordSphereComponent implements OnInit{
  @Select(ServiceState.getServicePatientRecordMode) recordMode$: Observable<SphereModeEnum>;
  @Select(AuthState.getIsExpert) isExpert$: Observable<boolean>;
  @Input() patientRelevantData: SPHERE.ISphere;
  @Input() patient: IPatient;
  @Input() userLogged: IUser;
  @Input() marksEasyOrDifficult: NzMarks;
  @Input() sedentaryLevel: any;
  @Input() levelActivity: ILevelActivityValues;
  @Input() loaded: boolean;

  @Output() redirectTo: EventEmitter<RecordTypeEnum> = new EventEmitter<RecordTypeEnum>();

  patientGoalNumberType = PatientGoalNumberTypeEnum;
  physicalActivityLevelEnum = PhysicalActivityLevelEnum;
  genderEnum = GenderEnum;
  recordTypeEnum = RecordTypeEnum;

  currentDate: Date = new Date();
  sepherMode = SphereModeEnum;
  skeletonTemplate: any[] = [];

  viewInformation: boolean;
  constructor(
    private utilitiesService: UtilitiesService,
    private store: Store,
    private activatedRoute: ActivatedRoute,
    private skeletonService: SkeletonService,
  ) {}

  ngOnInit(): void {
    this.skeletonTemplate = this.skeletonService.build(SkeletonEnum.SPHERE);
  }

  async onRedirectTo(record: RecordTypeEnum): Promise<void> {
    this.redirectTo.emit(record);
  }

  /**
   * This method closes the sphere and prevents propagation
   * @param event event of element HTML
   */
  async onCloseSphere(event: any): Promise<void> {
    event.stopPropagation();
    await firstValueFrom(this.store.dispatch(new PatientSphereAction.OpenSphere(false)));
  }

  async onSwitchSphere(): Promise<void> {
    this.loaded = false;
    const modeSphere = await firstValueFrom(this.recordMode$);

    await firstValueFrom(
      this.store.dispatch(
        new ServiceAction.SwitchBetweenSphereAndMiniSphere(
          this.store.selectSnapshot(ServiceState.getServiceSelectedId),
          this.store.selectSnapshot(PatientState.getSelectedPatient)?._id,
          modeSphere === this.sepherMode.MINI ? SphereModeEnum.COMPLETE : SphereModeEnum.MINI)));

  }
}
